var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuMapInactiveV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.5 4.5 10.5 15.5 15.5 11.5 15.5 0.5 10.5 4.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.5 4.5 10.5 15.5 5.5 11.5 5.5 0.5 10.5 4.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.5 4.5 0.5 15.5 5.5 11.5 5.5 0.5 0.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.3,
    stroke: "#000",
    d: "M16,.5s0,0,0-.06,0-.07,0-.1a.19.19,0,0,0-.05-.09l0-.06,0,0A.27.27,0,0,0,15.79.1l-.07,0-.1,0-.09,0h-.1l-.09,0-.1.05-.05,0L10.5,3.86,5.81.11l0,0,0,0L5.66,0H5.34l-.06,0,0,0,0,0-5,4,0,0a.27.27,0,0,0-.07.08l0,.07a.29.29,0,0,0,0,.09.44.44,0,0,0,0,.1,0,0,0,0,0,0,0v11s0,0,0,.06,0,.07,0,.1a.19.19,0,0,0,.05.09l0,.06,0,0a.34.34,0,0,0,.12.09s0,0,0,0A.46.46,0,0,0,.5,16h0a.39.39,0,0,0,.18,0l.06,0,.07,0L5.5,12.14l4.69,3.75.07,0,0,0h0a.42.42,0,0,0,.36,0h0l0,0,.07,0,5-4,0,0a.27.27,0,0,0,.07-.08l0-.08a.19.19,0,0,0,0-.08.44.44,0,0,0,0-.1,0,0,0,0,0,0,0ZM1,4.74l4-3.2v9.72l-4,3.2Zm5-3.2,4,3.2v9.72l-4-3.2Zm5,3.2,4-3.2v9.72l-4,3.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuMapInactiveV1);
export default __webpack_public_path__ + "static/media/Icon-Menu_Map_Inactive_v1.fbaf9565deb39163f9273a53c0562c10.svg";
export { ForwardRef as ReactComponent };